import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const URL_TEXT_FIELD_CLASS_NAME = 'URLTextField';
export const URL_TEXT_FIELD_CLASS_SLOTS = [
	'root',
	'endAdornment',
	'status',
] as const;

export type URLTextFieldClassSlot = (typeof URL_TEXT_FIELD_CLASS_SLOTS)[number];

export interface URLTextFieldClasses {
	root: string;
	endAdornment: string;
	status: string;
	invalid: string;
	valid: string;
}

export type URLTextFieldClassKey = keyof URLTextFieldClasses;

export const getURLTextFieldUtilityClass = (slot: string) =>
	generateUtilityClass(URL_TEXT_FIELD_CLASS_NAME, slot);

export const urlTextFieldClasses = generateUtilityClasses<
	keyof URLTextFieldClasses
>(URL_TEXT_FIELD_CLASS_NAME, [
	'root',
	'endAdornment',
	'invalid',
	'status',
	'valid',
]);
export default urlTextFieldClasses;
